import {envType} from "@/pages/Campaign/utils/common";
import {ENV_TYPE, JUMP_BRAND, JUMP_TYPE} from "@/pages/Campaign/utils/enum";
import _ from "lodash";
import h5plus from "@mainto/h5plus";
// eslint-disable-next-line
import { h5plusReday } from '@mainto/h5plus'

let env = envType()
let $h5plus = h5plus
h5plusReday().then((res) => {
  $h5plus = res
  if (res.isInApp()) {
    env = ENV_TYPE.APP
  }
})


function brandPath(brand) {
  switch (brand) {
  case JUMP_BRAND.BLUE:
    return 'blue'
  case JUMP_BRAND.GOLD:
    return 'gold'
  default:
    return ''
  }
}

// 产品详情跳转地址
function prodUrl(brand, productId) {
  if (!brand || !productId) return null

  const mpUrl = (brand) => {
    switch (brand) {
    case JUMP_BRAND.FAMILY:
      return `/pagesA/productDetail/index?id=${productId}`
    case JUMP_BRAND.MAN_TU:
      return `/pages/product/product?id=${productId}&module=campaign`
    case JUMP_BRAND.BLUE:
    case JUMP_BRAND.GOLD:
      return `/pagesA/product/prodDetail/index?brand=${brandPath(brand)}&showPid=${productId}&pickPid=${productId}`
    case JUMP_BRAND.TIAN_SHENG:
      return `/pages/goods/goodsDetails/goodsDetails?id=${productId}`
    default:
      return null
    }
  }

  switch (env) {
  case ENV_TYPE.WX_MP:
  case ENV_TYPE.ALI_MP:
  case ENV_TYPE.TT_MP:
    return mpUrl(brand)
  case ENV_TYPE.APP:
    return `/prodDetail/${brandPath(brand)}/${productId}/${productId}`
  case ENV_TYPE.H5:
    return process.env.VUE_APP_ENV_NEW_WEB_HOST + `prodDetail/${brandPath(brand)}/${productId}/${productId}`
  default:
    return null
  }
}

// 购买礼品卡跳转地址
function giftCardUrl(tid, cid) {
  switch (env) {
  case ENV_TYPE.WX_MP:
  case ENV_TYPE.ALI_MP:
  case ENV_TYPE.TT_MP:
  case ENV_TYPE.XHS_MP:
    return `/pagesB/giftCard/buy/detail/index?tid=${tid}&cid=${cid}`
  case ENV_TYPE.APP:
    return `/giftCard/buy/detail/${tid}/${cid}`
  case ENV_TYPE.H5:
    return process.env.VUE_APP_ENV_NEW_WEB_HOST + `giftCard/buy/detail/${tid}/${cid}`
  default:
    return null
  }
}

// 时予小程序跳转地址
function retailMPDetailUrl(retailId) {
  switch (env) {
  case ENV_TYPE.WX_MP:
    const encodeData = encodeURIComponent(`pages/product/goods-detail/index!id=${retailId}`)
    return `/pages/webview/jump?appId=wx8e54834d41fcc796&miniPath=${encodeData}`
  default:
    return null
  }
}

function manTuMPDetailUrl(productId) {
  switch (env) {
  case ENV_TYPE.WX_MP:
    const encodeData = encodeURIComponent(`pages/product/product?id=${productId}&module=campaign`)
    return `/pages/webview/jump?appId=wx295fb795503abb3c&miniPath=${encodeData}`
  default:
    return null
  }
}

function familyMPDetailUrl(productId) {
  switch (env) {
  case ENV_TYPE.WX_MP:
    const encodeData = encodeURIComponent(`pagesA/productDetail/index?id=${productId}`)
    return `/pages/webview/jump?appId=wx7187da6dfcd619c9&miniPath=${encodeData}`
  default:
    return null
  }
}

function himoMPDetailUrl(brand, productId) {
  switch (env) {
  case ENV_TYPE.WX_MP:
    const encodeData = encodeURIComponent(`pagesA/product/prodDetail/index?brand=${brandPath(brand)}&showPid=${productId}&pickPid=${productId}`)
    return `/pages/webview/jump?appId=${process.env.VUE_APP_ENV_HIMO_MINI_ID}&miniPath=${encodeData}`
  default:
    return null
  }
}

export function jumpUrl(params) {
  if (!params?.type) return null

  switch (params.type) {
  case JUMP_TYPE.ACTIVITY:
    return params.url
  case JUMP_TYPE.PRODUCT:
    return prodUrl(params.brand, params.productId)
  case JUMP_TYPE.GIFT_CARD:
    return giftCardUrl(params.giftId, params.giftCoverId)
  case JUMP_TYPE.FAMILY_MP_DETAIL:
    return familyMPDetailUrl(params.productId)
  case JUMP_TYPE.MAN_TU_MP_DETAIL:
    return manTuMPDetailUrl(params.productId)
  case JUMP_TYPE.HIMO_MP_DETAIL:
    return himoMPDetailUrl(params.brand, params.productId)
  case JUMP_TYPE.RETAIL_MP_DETAIL:
    return retailMPDetailUrl(params.retailId)
  default:
    return null
  }
}

export function jump(url) {
  if (!url) return

  switch (env) {
  case ENV_TYPE.WX_MP:
    let wxMini = window.wx.miniProgram;
    // 测试发现，miniProgram时有时没有？ 到底是window.wx 还是window.wx.miniProgram
    if (_.isEmpty(wxMini)) {
      window.wx.navigateTo({ url });
    }

    window.wx.miniProgram.navigateTo({ url })
    break
  case ENV_TYPE.TT_MP:
    window.tt.miniProgram.navigateTo({ url })
    break
  case ENV_TYPE.ALI_MP:
    window.my.navigateTo({ url })
    break
  case ENV_TYPE.XHS_MP:
    xhs.miniProgram.navigateTo({ url })
    break
  case ENV_TYPE.APP:
    if (url.startsWith('http')) {
      window.$location.href = url
    } else {
      $h5plus.navigate({ path: url })
    }
    break
  case ENV_TYPE.H5:
    window.location = url
    break
  default:
    break
  }
}
